import Tech from 'components/Tech';
import classes from './Project.module.scss';
import { Fade } from 'react-reveal';

function Features({ list }) {
  return (
    <Fade bottom distance={'2rem'}>
      <ul className={classes.features}>
        {list.map((feature, key) => (
          <li className={classes.feature} key={key}>
            {feature}
          </li>
        ))}
      </ul>
    </Fade>
  );
}

export default function Project(props) {
  const { images, logo, type, title, children, features, stack, link, clientCode, serverCode, code } = props;
  /*
   * images: image -> type: object<Object<images>> dark: {small, large}, light: {small, large}
   * type -> type: string [eg. featured]
   * tech -> type: array<string>
   * link -> landing page url
   * code -> source code repository url
   * children : description -> type: string
   * features -> Array<string>
   * logo: logo of the project -> type: string<image>
   */
  return (
    <Fade bottom distance={'4rem'}>
      <div className={classes.project}>
        <figure className={classes.project__picture}>
          <img
            className={classes.project__image}
            alt={title}
            src={images.dark.small}
            srcSet={`${images.dark.small} 200w, ${images.dark.large} 600w`}
          />

          <figcaption className={classes.caption}>
            {clientCode && (
              <a href={clientCode} target='_blank' rel='noopener noreferrer' className='icon'>
                &#xe900; <span className={classes.link}>Client Code</span>
              </a>
            )}
            {serverCode && (
              <a href={serverCode} target='_blank' rel='noopener noreferrer' className='icon'>
                &#xe900; <span className={classes.link}>Server Code</span>
              </a>
            )}
            {code && (
              <a href={code} target='_blank' rel='noopener noreferrer' className='icon'>
                &#xe900; <span className={classes.link}>Code</span>
              </a>
            )}
            {link && (
              <a href={link} target='_blank' rel='noopener noreferrer' className='icon'>
                &#xe904; <span className={classes.link}>Live Site</span>
              </a>
            )}
          </figcaption>

          <div className={classes.project__logo}>
            <img src={logo} alt={title} />
          </div>
        </figure>

        <div className={classes.project__details}>
          <div className={classes.sub_heading}>{type}</div>

          <h4 className={classes.project__title}>
            <a href={link}>{title}</a>
          </h4>

          <p className={classes.project__description}>{children}</p>
          <Features list={features} />
          <div className={classes.project__techStack}>
            {stack.map((value, index) => (
              <Tech value={value} key={index} />
            ))}
          </div>
        </div>
      </div>
    </Fade>
  );
}

